var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81121 12.6267L10.4979 8.93333C10.7445 8.68667 10.8845 8.34667 10.8845 7.99333V1.33333C10.8845 0.6 10.2845 0 9.55121 0H3.55788C3.02454 0 2.54454 0.32 2.33788 0.806667L0.164542 5.88C-0.402124 7.2 0.564543 8.66667 1.99788 8.66667H5.76454L5.13121 11.72C5.06454 12.0533 5.16454 12.3933 5.40454 12.6333C5.79788 13.02 6.42454 13.02 6.81121 12.6267ZM13.5579 0C12.8245 0 12.2245 0.6 12.2245 1.33333V6.66667C12.2245 7.4 12.8245 8 13.5579 8C14.2912 8 14.8912 7.4 14.8912 6.66667V1.33333C14.8912 0.6 14.2912 0 13.5579 0Z",
    fill: "#8E8E8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbdown);
export default __webpack_public_path__ + "static/media/thumbdown.a8228ee47a0492db2576f5bbfb5cea65.svg";
export { ForwardRef as ReactComponent };